document.addEventListener('DOMContentLoaded', function () {
    let showdownLoaded = false;

    const modalElement = document.getElementById('offcanvasComments');

    if (modalElement) {
        modalElement.addEventListener('shown.bs.offcanvas', function () {
            if (!showdownLoaded) {
                loadScript(g_devtricker_Settings.themeUrl + '/dist/js/showdown.min.js', function () {
                    showdownLoaded = true;
                    console.log('showdown loaded!');
                });
            }
        });
    }
});


document.addEventListener('DOMContentLoaded', function () {
    const inputField = document.querySelector('#comment');

    if (inputField) {
        if (devtricker_getTheLoggedUserId()) {
            inputField.removeAttribute("virtualkeyboardpolicy");
        }
    }
});